import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "latex-editor" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "input-area" }
const _hoisted_5 = { class: "preview" }
const _hoisted_6 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_7 = {
  key: 1,
  class: "preview-content"
}
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "symbol"
}
const _hoisted_13 = { class: "symbol-tabs" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "symbol-pool" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "formula"
}
const _hoisted_18 = { class: "formula-title" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_FormulaContent = _resolveComponent("FormulaContent")!
  const _component_SymbolContent = _resolveComponent("SymbolContent")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextArea, {
            value: _ctx.latex,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.latex) = $event)),
            placeholder: "输入 LaTeX 公式",
            ref: "textAreaRef"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.latex)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "公式预览"))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_FormulaContent, {
                  width: 518,
                  height: 138,
                  latex: _ctx.latex
                }, null, 8, ["latex"])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["tab", { 'active': tab.value === _ctx.toolbarState }]),
              key: tab.value,
              onClick: ($event: any) => (_ctx.toolbarState = tab.value)
            }, _toDisplayString(tab.label), 11, _hoisted_10))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.toolbarState === 'symbol')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.symbolList, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["symbol-tab", { 'active': _ctx.selectedSymbolKey === group.type }]),
                      key: group.type,
                      onClick: ($event: any) => (_ctx.selectedSymbolKey = group.type)
                    }, _toDisplayString(group.label), 11, _hoisted_14))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.symbolPool, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "symbol-item",
                      key: item.latex,
                      onClick: ($event: any) => (_ctx.insertSymbol(item.latex))
                    }, [
                      _createVNode(_component_SymbolContent, {
                        latex: item.latex
                      }, null, 8, ["latex"])
                    ], 8, _hoisted_16))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formulaList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "formula-item",
                    key: item.label
                  }, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.label), 1),
                    _createElementVNode("div", {
                      class: "formula-item-content",
                      onClick: ($event: any) => (_ctx.latex =item.latex)
                    }, [
                      _createVNode(_component_FormulaContent, {
                        width: 236,
                        height: 60,
                        latex: item.latex
                      }, null, 8, ["latex"])
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Button, {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update()))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ])
  ]))
}